import { UsingObservable } from './UsingObservable';
export var using = UsingObservable.create;
//# sourceMappingURL=using.js.map